<template>
  <div class="day-interim-screen-root">
    <vs-popup :active.sync="isActive" title="Gün Ortası" class="day-interim-main-popup">
      <vs-row vs-type="flex" vs-w="12" class="mt-4">
        <vs-col vs-type="flex" vs-w="12" vs-justify="center">
          <h3>Lütfen Kasadaki Nakit Parayı Sayarak Gün Ortasını Yapınız</h3>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-4">
        <vs-col vs-type="flex" vs-w="12" vs-justify="center">
          <vs-input
            @focus="$event.target.select()"
            id="Nakit"
            name="Nakit"
            v-validate="'required'"
            v-model="safeCash"
            label-placeholder="Kasa Anlık Nakit: "
            @input="handleInput"
          />
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-4">
        <vs-col vs-type="flex" vs-w="12" vs-justify="center">
          <vs-button @click="showPopup" size="large" color="transparent" class="bold bg-success text-white ml-2">
            Onayla
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup
      :active.sync="showPopupFlag"
      title="Gün ortası onayı"
      class="day-interim-confirm-popup"
    >
      <div class="day-interim-confirm__body">
        <p class="day-interim-confirm__message">
          Ara raporu kaydetmek istediğinize emin misiniz?
        </p>
        <div class="day-interim-confirm__actions">
          <vs-button type="filled" color="success" class="day-interim-confirm__btn" @click="forcelose">
            Evet
          </vs-button>
          <vs-button
            type="border"
            color="danger"
            class="day-interim-confirm__btn day-interim-confirm__btn-no"
            @click="closePopup"
          >
            Hayır
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { createDayInterim } from "@/api/DayOpen.js";
import companyInfo from "../../../model/constants/companyInfo";
export default {
  data() {
    return {
      isActive: false,
      logo: companyInfo.logo,
      showPopupFlag: false,
      safeCash: 0,
      xCash: 0,
      multinet: 0,
      sodexo: 0,
      ticket: 0,
      setCard: 0,
      migros: 0,
      metropol: 0,
      tokenflex: 0,
      getir: 0,
      yemekSepeti: 0,
      trendyol: 0,
    };
  },
  computed: {
    activePersonel: function () {
      return this.$store.getters["selfservice/getActivePersonal"];
    },
  },
  watch: {
    isActive(val) {
      this.safeCash = 0;
    },
  },
  methods: {
    handleInput() {
      if (this.safeCash !== null) {
        const regex = /^\d+(\.\d{0,2})?$/;
        if (!regex.test(this.safeCash)) {
          this.safeCash = this.safeCash.slice(0, -1);
        }
      }
    },
    showPopup: async function () {
      const checker = await this.$validator.validateAll();
      if (!checker) {
        return;
      }
      this.showPopupFlag = true;
    },
    closePopup() {
      this.showPopupFlag = false;
    },
    forcelose: async function () {
      this.showPopupFlag = false;
      try {
        const res = await createDayInterim({
          safeCash: this.safeCash,
          xReportForCard: this.xCash,
          multinetReport: this.multinet,
          sodexoReport: this.sodexo,
          ticketReport: this.ticket,
          setcardReport: this.setCard,
          metropolReport: this.metropol,
          tokenflexReport: this.tokenflex,
          getirReport: this.getir,
          yemekSepetiReport: this.yemekSepeti,
          trendyolReport: this.trendyol,
          migrosReport: this.migros,
          userId: this.activePersonel.id,
          userName: this.activePersonel.name,
        });
        if (res && res.status == 200) {
          this.$vs.notify({
            color: "success",
            title: "Gün ortası başarılı",
            text: "Gün ortası başarılı !",
          });
          this.$emit("emitDisable", true);
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Ödeme Raporu Yüklenemedi !",
          });
        }
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !",
        });
      }
      this.isActive = false;
    },
    preventCloseOnClick() {},
    handlePopupUpdate(newValue) {
      if (!newValue) {
        this.isActive = true;
      }
    },
  },
};
</script>

<style scoped>
.day-interim-screen-root {
  display: block;
}

.day-interim-confirm__body {
  padding: 1.35rem 1.5rem 1.5rem;
  text-align: center;
  max-width: 22rem;
  margin: 0 auto;
  box-sizing: border-box;
}

.day-interim-confirm__message {
  margin: 0 0 1.35rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #3a2a28;
  font-weight: 600;
}

.day-interim-confirm__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: center;
  align-items: center;
}

.day-interim-confirm__btn {
  flex: 1 1 auto;
  min-width: 7.5rem;
  font-weight: 700 !important;
}

.day-interim-confirm__btn-no.vs-button-border ::v-deep .vs-button--text {
  color: #7f1010 !important;
}

.day-interim-confirm__btn-no.vs-button-border {
  border-color: #c62828 !important;
}
</style>

<style>
.con-vs-popup.day-interim-main-popup {
  z-index: 120000 !important;
}

.con-vs-popup.day-interim-confirm-popup {
  z-index: 140000 !important;
}

.day-interim-confirm-popup.vs-popup-primary .vs-popup--content {
  padding: 0 !important;
}

.logo {
  background-color: white;
  border-radius: 10px;
  margin-bottom: 1rem;
}
#switchScreen {
  z-index: 999999;
}
#switchScreen .vs-popup .vs-popup--header {
  display: none !important;
}

#switchScreen .vs-popup .vs-popup--content {
  padding: 0 !important;
}

#switchScreen .vs-popup {
  background: transparent !important;
  box-shadow: none !important;
}

#switchScreen input {
  font-size: 2rem !important;
  background: #f2f2f2 0% 0% no-repeat padding-box !important;
  text-align: center !important;
  padding: 0.5rem;
}
</style>
